import { render, staticRenderFns } from "./BinMapping.vue?vue&type=template&id=74592054"
import script from "./BinMapping.vue?vue&type=script&lang=js"
export * from "./BinMapping.vue?vue&type=script&lang=js"
import style0 from "./BinMapping.vue?vue&type=style&index=0&id=74592054&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports